import { ReactElement, useState } from 'react'

import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import Paper from '@mui/material/Paper'

import { CancelIcon, ConfirmIcon } from 'src/v3/core/icons'

interface Props {
  open: string
  setOpen: any
  openText: string
  text: string
  executeAction: () => Promise<unknown>
  confirmText?: string
  title?: string
  onFailure?: (err: any) => void
}

let ConfirmAction = ({
  open,
  setOpen,
  openText,
  executeAction,
  confirmText,
  title,
  text,
  onFailure,
}: Props): ReactElement => {
  let [executing, setExecuting] = useState(false)

  return (
    <Dialog
      onClose={() => setOpen('')}
      open={open === openText}
      aria-labelledby="confirm-dialog-title"
      aria-describedby="confirm-dialog-description"
    >
      <Paper className="px-3 py-1">
        <DialogTitle id="confirm-dialog-title" sx={{ textAlign: 'center' }}>
          {title || 'Confirm'}
        </DialogTitle>
        <DialogContent id="confirm-dialog-description" className="px-2">
          {text}
        </DialogContent>
        <DialogActions className="flex justify-center pt-0 pb-3">
          <Button
            onClick={() => {
              setExecuting(true)
              executeAction()
                .then(() => setExecuting(false))
                .then(() => setOpen(''))
                .catch((err) => {
                  setOpen('')
                  setExecuting(false)
                  if (onFailure)
                    onFailure(err.data?.response || err.data?.status || err)
                })
            }}
            color="primary"
            variant="contained"
            sx={{ flex: '1 1 0px', minHeight: 44 }}
            startIcon={<ConfirmIcon />}
            aria-label={`Confirm: ${title || 'Confirm'}`}
            loading={executing}
          >
            {confirmText || 'Confirm'}
          </Button>
          <Button
            onClick={() => setOpen('')}
            color="error"
            variant="contained"
            sx={{ flex: '1 1 0px', minHeight: 44 }}
            startIcon={<CancelIcon />}
            aria-label="Cancel action"
            disabled={executing}
          >
            Cancel
          </Button>
        </DialogActions>
      </Paper>
    </Dialog>
  )
}

export default ConfirmAction
